import { Injectable } from '@angular/core';
import { RoleApiService } from '../../services/role-api/role-api.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { RoleActions } from '../actions';
import { catchError, map, mergeMap, throwError } from 'rxjs';
import { Store } from '@ngrx/store';

@Injectable()
export class RoleEffects {
  constructor(private actions: Actions, private roleApi: RoleApiService, private store: Store) {}

  loadRoles$ = createEffect(() =>
    this.actions.pipe(ofType(RoleActions.loadRoles)).pipe(
      mergeMap(() => this.roleApi.getRoles()),
      map((roles) => RoleActions.rolesLoaded({ roles })),
    ),
  );

  createRole$ = createEffect(() =>
    this.actions.pipe(ofType(RoleActions.createRole)).pipe(
      mergeMap((action) =>
        this.roleApi.createRole(action.role).pipe(
          catchError((err) => {
            this.store.dispatch(RoleActions.roleCreationFailed({ role: action.role }));
            return throwError(() => err);
          }),
        ),
      ),
      map((role) => RoleActions.roleCreated({ role })),
    ),
  );

  editRole$ = createEffect(() =>
    this.actions.pipe(ofType(RoleActions.updateRole)).pipe(
      mergeMap((action) =>
        this.roleApi.updateRole(action.role).pipe(
          catchError((err) => {
            this.store.dispatch(RoleActions.roleUpdateFailed({ role: action.role }));
            return throwError(() => err);
          }),
        ),
      ),
      map((role) => RoleActions.roleUpdated({ role })),
    ),
  );

  deleteRole$ = createEffect(() =>
    this.actions.pipe(ofType(RoleActions.deleteRole)).pipe(
      mergeMap((action) =>
        this.roleApi.deleteRole(action.role.key).pipe(
          map(() => action.role),
          catchError((err) => {
            this.store.dispatch(RoleActions.roleDeleteFailed({ role: action.role }));
            return throwError(() => err);
          }),
        ),
      ),
      map((role) => RoleActions.roleDeleted({ role })),
    ),
  );
}
